import { createSlice } from '@reduxjs/toolkit';
import { HYDRATE } from 'next-redux-wrapper';

import { SearchReq } from '@/type/pages';

type State = {
  categoryPage: {
    records: any[];
    total: number;
    page: number;
    pageSize: number;
    totalPage: number;
  };
  cateTags: any;
  productTags: any;
  allCategory: any[];
  allCategoryLanding: any[];
  
  searchRequest: SearchReq;
}

const initialState: State = {
  categoryPage: {
    records: [],
    total: 0,
    page: 1,
    pageSize: 10,
    totalPage: 0
  },
  cateTags: [],
  productTags: [],
  allCategory: [],
  allCategoryLanding: [],
  
  searchRequest: {
    page: 1,
    pageSize: 9,
    language: 'zh-hk',
    sortBy: 'publishDate',
    topicTagEntryIds: [],
    prodTagEntryIds: []
  }
}

const NAME = 'categoryPage';

export const categoryPageSlice = createSlice({
  name: NAME,
  initialState,
  reducers: {
    changeCategoryPage: (state, action) => {
      state.categoryPage = action.payload
    },
    changeAllCategoryLanding: (state, action) => {
      state.allCategoryLanding = action.payload
    },
    changeCateTags: (state, action) => {
      state.cateTags = action.payload
    },
    changeProductTags: (state, action) => {
      state.productTags = action.payload
    },
    changeAllCategory: (state, action) => {
      state.allCategory = action.payload
    },
  
    changeSearchRequest: (state, action) => {
      state.searchRequest = action.payload
    },
  },
  extraReducers: builder => {
    builder.addCase(HYDRATE, (state, action: any) => ({
      ...state,
      ...action.payload[NAME]
    }))
  },
})

export const {
  changeCategoryPage,
  changeAllCategoryLanding,
  changeCateTags,
  changeProductTags,
  changeAllCategory,
  changeSearchRequest
} = categoryPageSlice.actions;
export default categoryPageSlice;
